export function ThemeSwitchSkeleton() {
  return <div className="skeleton size-8 rounded-full"></div>;
}
